define("Item.Model.Ext", ["Item.Model", "underscore"], function (ItemModel, _) {
  "use strict";

  //These models have been extended to add extra parameter to avoid getting cached data
  _.extend(ItemModel.prototype, {
    getThumbnail: function getThumbnail() {
      var objThumb = this.get("_thumbnail");

      var objThumbNew = {
        url: this.get("custitemitemimageurl1"),
        altimagetext: "",
      };

      if (this.get("custitemitemimageurl1")) {
        if (objThumb && objThumb.altimagetext) {
          objThumbNew.altimagetext = objThumb.altimagetext;
        }
        return objThumbNew;
      }

      // return the no image available stuff
      return objThumb;
    },
  });
});
